import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './GenerateLinkModal.module.scss';
export const GenerateLinkModal = (param)=>{
    let { recipientsCount, dismissModal } = param;
    const { t: silentProposalTexts } = useLocaleKeys('components.agreementStudio.silentProposal');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'generate_link_confirm'
            },
            secondaryButton: {
                name: 'generate_link_cancel'
            }
        },
        testId: 'generate-link-modal',
        title: silentProposalTexts.shareByLink(),
        width: "800px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.generateModalContent,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: silentProposalTexts.generateLinkDescription()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: silentProposalTexts.pleaseNote()
                }),
                /*#__PURE__*/ _jsxs("ul", {
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: silentProposalTexts.statusChangeSent()
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: silentProposalTexts.clientReminders()
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: silentProposalTexts.uniqueLink()
                            })
                        })
                    ]
                })
            ]
        }),
        onCloseButtonClick: ()=>dismissModal(false),
        secondaryButtonLabel: commonButtons.cancel(),
        secondaryButtonTestId: "generate-link-modal-cancel",
        onSecondaryButtonClick: ()=>dismissModal(false),
        primaryButtonLabel: silentProposalTexts.generateButton({
            count: recipientsCount
        }),
        primaryButtonTestId: "generate-link-modal-generate",
        onPrimaryButtonClick: ()=>{
            dismissModal(true);
        }
    });
};
